import { Layout, theme as antdTheme } from 'antd';
import { Outlet } from 'react-router-dom';
import classes from './AppLayout.module.scss';
import Header from '../Header/Header';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import Footer from '../Footer/Footer';
import { SessionTimeoutModal } from 'shared/ui';
import { useSessionTimeout } from 'shared/libs/hooks/useSessionTimeout';

const AuthLayout = () => {
  const {
    token: { colorBgBase },
  } = antdTheme.useToken();
  
  const { showModal, secondsRemaining, handleExtend, handleLogout } = useSessionTimeout({
    warningTime: 60,
    inactivityTimeout: 15 * 60 * 1000,
  });

  return (
    <Layout className={classes.container} style={{ backgroundColor: colorBgBase }}>
      <Header />
      <Layout.Content className={classes.contentContainer}>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </Layout.Content>
      <Footer />
      <SessionTimeoutModal
        open={showModal}
        secondsRemaining={secondsRemaining}
        onExtend={handleExtend}
        onLogout={handleLogout}
      />
    </Layout>
  );
};

export default AuthLayout;
